import { __assign, __generator } from "tslib";
import { put, select } from 'redux-saga/effects';
import { getGallectionById } from '../selectors';
import { putEntities } from '../../redux/entities/actions';
import { normalizeGallection } from '../../redux/normalizr/helpers';
function updateGallectionSize(folderId, delta) {
    var gallection, updatedGallection, entities;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getGallectionById, folderId)];
            case 1:
                gallection = _a.sent();
                if (!gallection) {
                    return [2 /*return*/];
                }
                updatedGallection = __assign(__assign({}, gallection), { size: gallection.size + delta });
                entities = normalizeGallection(updatedGallection);
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default updateGallectionSize;
//# sourceMappingURL=updateGallectionSize.js.map